import { GetServerSideProps, InferGetServerSidePropsType } from 'next';

import { Layout } from 'components/Layout';
import PageContent from 'components/page-content/dashboard/PageContent';
import { Seo } from 'components/seo';
import { cleanConfig } from 'lib/datoCms/utils';
import { getAllLabelsPersonalAreas } from 'lib/datoCms/queries/getAllLabelsPersonalAreas';
import { getAllSidebarNavigations } from 'lib/datoCms/queries/getAllSidebarNavigations';
import { getDashboardPage } from 'lib/datoCms/queries/getDashboardPage';
import { getDatoCMSData } from 'sites/snai/lib/datoCms/queries/getDatoCMSData';
import { getMyAccountPage } from 'lib/datoCms/queries/getMyAccountPage';
import { getMyBonusPage } from 'lib/datoCms/queries/getMyBonusPage';
import { getMyDataPage } from 'lib/datoCms/queries/getMyDataPage';
import { labelsFromPageProps } from 'common/hooks/useLingUI';

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  console.log('getServerSideProps : dashboard');

  try {
    const prCMSData = getDatoCMSData('common', locale);
    const prLabels = getAllLabelsPersonalAreas(locale);
    const prMyData = getMyDataPage(locale!);
    const prMyBonus = getMyBonusPage(locale!);
    const prMyAccount = getMyAccountPage(locale!);
    const prDashboard = getDashboardPage(locale!);
    const prNavigation = getAllSidebarNavigations(locale!);

    const [
      CMSData,
      labels,
      { myDataPage },
      { myBonusPage },
      { myAccountPage },
      { dashboardPage },
      { allSidebarNavigations },
    ] = await Promise.all([prCMSData, prLabels, prMyData, prMyBonus, prMyAccount, prDashboard, prNavigation]);
    const { site, header, needHelp, footer, config } = CMSData;

    return {
      props: {
        site,
        header,
        footer,
        labels,
        config: cleanConfig(config),
        needHelp,
        myDataPage,
        myBonusPage,
        dashboardPage: Object.assign({}, config, dashboardPage),
        myAccountPage,
        sidebarNavigationList: allSidebarNavigations,
      },
    };
  } catch (error) {
    console.log('error', error);
    return { notFound: true };
  }
};

const Dashboard = (props: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  labelsFromPageProps(props);

  const {
    site,
    header,
    footer,
    needHelp,
    myDataPage,
    myBonusPage,
    dashboardPage,
    myAccountPage,
    sidebarNavigationList,
  } = props;

  const { seoMetaTags, canonical } = dashboardPage ?? {};

  return (
    <Layout header={header} footer={footer} needHelp={needHelp}>
      <Seo siteSeo={site} metaTags={seoMetaTags} canonicalUrl={canonical} />
      <PageContent
        myBonusPage={myBonusPage}
        sidebarNavigationList={sidebarNavigationList}
        dashboardPage={dashboardPage}
        myDataPageUrl={myDataPage.href}
        myAccountPage={myAccountPage}
      />
    </Layout>
  );
};

export default Dashboard;
